import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, memo, useCallback } from 'react';
import Pagination from '../../../Pagination';
import { carSearch } from '../../../../store/slices/car';

const CarsPagination = ({ tripId, selectedTab }) => {
  const carSearchState = useSelector((store) => store.car.carSearches[tripId]);
  const dispatch = useDispatch();
  const responses = useSelector((state) => state.car.responses);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (carSearchState && responses) {
      setResponse(responses[carSearchState.carTabs[selectedTab].queryString]);
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [carSearchState]);

  const handleNextPageClick = useCallback(() => {
    const { page, pageSize } = carSearchState.carTabs[selectedTab].searchObj;
    const { totalCars } = response;
    const p = page * pageSize + (totalCars % pageSize) > totalCars ? page : page + 1;

    if (p > page) {
      dispatch(
        carSearch({
          tripId,
          selectedTab,
          searchObj: {
            page: p,
          },
        }),
      );
    }
  }, [carSearchState, dispatch, tripId, response, selectedTab]);

  const handlePrevPageClick = useCallback(() => {
    const {
      searchObj: { page },
    } = carSearchState.carTabs[selectedTab];
    const p = page - 1 > 0 ? page - 1 : page;
    if (p < page) {
      dispatch(
        carSearch({
          tripId,
          selectedTab,
          searchObj: {
            page: p,
          },
        }),
      );
    }
  }, [carSearchState, dispatch, selectedTab, tripId]);

  return (
    carSearchState && (
      <Pagination
        page={carSearchState.carTabs[selectedTab].searchObj.page}
        pageSize={carSearchState.carTabs[selectedTab].searchObj.pageSize}
        totalCount={(response || {}).totalCars}
        onPrevPageClick={handlePrevPageClick}
        onNextPageClick={handleNextPageClick}
        resultsLabel="cars"
      />
    )
  );
};

CarsPagination.propTypes = {
  tripId: PropTypes.string.isRequired,
  selectedTab: PropTypes.number.isRequired,
};

export default memo(CarsPagination);
